// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { ExportService } from "./export.service"
import { GraphService } from "./graph.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./export.service"
export * from "./graph.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const dataServiceRegistry = {
    export: new ExportService(),
    graph: new GraphService(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type DataServiceRegistry = typeof dataServiceRegistry
